import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import { AsignedToPerson } from 'interfaces/assigned.interface';
import { ResizeCallbackData } from 'react-resizable';
import VZ__Resizable from 'components/resizable';
import ActionButton from 'components/buttons/action';
import { useAppDispatch } from 'reduxStore/hooks';
import emptyDataIcon from 'assets/images/logos/emptyDataIcon.png';

import {} from 'reduxStore/hooks';
export default function AsignedAssetsTable({ xmlData, AssignedColumns, tableWith }: any) {
    const [columns, setColumns] = useState(AssignedColumns);
    const dispatch = useAppDispatch();
    const [showEmptyText, setShowEmptyText] = useState(false);
    useEffect(() => {
        if (AssignedColumns) {
            setColumns(AssignedColumns);
        }
    }, [AssignedColumns]);

    const components = {
        header: {
            cell: VZ__Resizable,
        },
    };

    const resizableColumns = columns?.map((col: any, index: any) => {
        return {
            ...col,
            onHeaderCell: (column: any) => ({
                width: column.width,
                onResize: handleResize(index),
            }),
        };
    });

    const handleResize =
        (index: number) =>
        (e: React.SyntheticEvent<Element>, { size }: ResizeCallbackData) => {
            setColumns((prevColumns: any) => {
                const nextColumns = [...prevColumns];
                nextColumns[index] = {
                    ...nextColumns[index],
                    width: size.width,
                };
                return nextColumns;
            });
        };

    const locale = {
        emptyText:
            xmlData?.length === 0 ? (
                <div className="VZ__table__empty">
                    <div className="VZ__table__empty__container">
                        <div className="VZ__table__empty__icon">
                            <img src={emptyDataIcon} alt="emptyDataIcon" />
                        </div>
                        <div className="VZ__table__empty__text">No matches</div>
                    </div>
                </div>
            ) : (
                <></>
            ),
    };
    return (
        <Table<AsignedToPerson>
            components={components}
            // onRow={(record, rowIndex) => {
            //     return {};
            // }}
            scroll={xmlData?.length > 0 ? { x: tableWith, y: 468 } : undefined}
            loading={false}
            columns={xmlData && resizableColumns}
            pagination={{ pageSize: 20, position: ['bottomCenter'] }}
            className="vz__custom-table"
            dataSource={xmlData?.map((item: any, index: number) => ({
                ...item,
                key: `key-table-${index}`,
            }))}
            locale={locale}
            footer={() => (
                <>
                    <ActionButton
                        title={'Close'}
                        type="close"
                        onClick={() => {
                            window.closeVizorWindow();
                        }}
                    />
                </>
            )}
        />
    );
}
